module.exports = __webpack_public_path__ + "static/assets/dcf520ecbf617e4a33190a36f0e25658.svg";